import { Navigate, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/app/ProtectedRoute";
import { Shell } from "@/app/Shell";
import { AdminShell } from "@/app/AdminShell";
import { HomePage } from "@/pages/HomePage";
import { EventsPage } from "@/pages/EventsPage";
import { MapPage } from "@/pages/MapPage";
import { CommunityPage } from "@/pages/CommunityPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { PlayPage } from "@/pages/play/PlayPage";
import { PlaySearchPage } from "@/pages/play/PlaySearchPage";
import { GameBoardPage } from "@/pages/play/GameBoardPage";
import { ProfileMatchesPage } from "@/pages/profile/ProfileMatchesPage";
import { ProfileTournamentsPage } from "@/pages/profile/ProfileTournamentsPage";
import { AdminTournamentsPage } from "@/pages/admin/AdminTournamentsPage";
import { AdminTournamentNewPage } from "@/pages/admin/AdminTournamentNewPage";
import { AdminTournamentEditPage } from "@/pages/admin/AdminTournamentEditPage";
import { AdminTournamentDetailPage } from "@/pages/admin/AdminTournamentDetailPage";
import { AdminTrainingsPage } from "@/pages/admin/AdminTrainingsPage";
import { AdminTrainingFormPage } from "@/pages/admin/AdminTrainingFormPage";
import { AdminSpotsPage } from "@/pages/admin/AdminSpotsPage";
import { AdminSpotNewPage } from "@/pages/admin/AdminSpotNewPage";
import { AdminSpotEditPage } from "@/pages/admin/AdminSpotEditPage";
import { AdminUsersPage } from "@/pages/admin/AdminUsersPage";
import { AdminBroadcastPage } from "@/pages/admin/AdminBroadcastPage";
import { AdminProxyPage } from "@/pages/admin/AdminProxyPage";
import { AdminPlayPage } from "@/pages/admin/AdminPlayPage";
import { AdminOnly } from "@/app/AdminOnly";

export function App() {
  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route path="/"          element={<HomePage />} />
        <Route path="/events"    element={<EventsPage />} />
        <Route path="/map"       element={<MapPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/profile"             element={<ProfilePage />} />
        <Route path="/profile/matches"     element={<ProfileMatchesPage />} />
        <Route path="/profile/tournaments" element={<ProfileTournamentsPage />} />
        <Route path="/play"                element={<PlayPage />} />
        <Route path="/play/search"         element={<PlaySearchPage />} />
        <Route path="/play/game/:id"       element={<GameBoardPage />} />
      </Route>

      <Route
        path="/admin"
        element={
          <ProtectedRoute requireStaff>
            <AdminShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/admin/trainings" replace />} />
        <Route path="trainings"            element={<AdminTrainingsPage />} />
        <Route path="trainings/new"        element={<AdminTrainingFormPage mode="create" />} />
        <Route path="trainings/:id/edit"   element={<AdminTrainingFormPage mode="edit" />} />
        <Route path="tournaments"          element={<AdminOnly><AdminTournamentsPage /></AdminOnly>} />
        <Route path="tournaments/new"      element={<AdminOnly><AdminTournamentNewPage /></AdminOnly>} />
        <Route path="tournaments/:id"      element={<AdminOnly><AdminTournamentDetailPage /></AdminOnly>} />
        <Route path="tournaments/:id/edit" element={<AdminOnly><AdminTournamentEditPage /></AdminOnly>} />
        <Route path="spots"                element={<AdminOnly><AdminSpotsPage /></AdminOnly>} />
        <Route path="spots/new"            element={<AdminOnly><AdminSpotNewPage /></AdminOnly>} />
        <Route path="spots/:id/edit"       element={<AdminOnly><AdminSpotEditPage /></AdminOnly>} />
        <Route path="users"                element={<AdminOnly><AdminUsersPage /></AdminOnly>} />
        <Route path="broadcast"            element={<AdminOnly><AdminBroadcastPage /></AdminOnly>} />
        <Route path="proxy"                element={<AdminOnly><AdminProxyPage /></AdminOnly>} />
        <Route path="play"                 element={<AdminOnly><AdminPlayPage /></AdminOnly>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
